module.exports = __webpack_public_path__ + "img/hzgs4.60748fbf.png";